/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @file Input component for color input
 * @author Heino Lenting, Maarten Lensink

 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sym-color-read-only[_ngcontent-%COMP%]   .sym-color[_ngcontent-%COMP%]{height:27px;margin-top:1px;padding:0 6px;font-size:.875rem}.sym-color-picker[_ngcontent-%COMP%]   .sym-colors[_ngcontent-%COMP%]{overflow:visible}.sym-color-picker[_ngcontent-%COMP%]   .sym-colors[_ngcontent-%COMP%]   .sym-color[_ngcontent-%COMP%]{width:16.66666667%;height:20px;float:left;border-style:solid;cursor:pointer}.sym-color-picker[_ngcontent-%COMP%]   .sym-colors[_ngcontent-%COMP%]   .sym-color.sym-parent-color[_ngcontent-%COMP%]{width:100%;margin-top:5px;text-align:center;font-size:.8rem;display:table}"];
export { styles as styles };
